import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Search from '../components/search'
import Loading from '../components/loading'
import Ajax from '../components/ajax'
import { useDispatch, useSelector } from 'react-redux'
import { userLogin } from '../store/slices/mainSlices'
import Pagination from '../components/pagination'
import Modal from '../components/modal'
import { useForm } from 'react-hook-form'
import { branchesAdd } from '../store/slices/mainSlices'

import defaultImage from '../images/default.png'

export default function Students() {
  //Translate initialization
  const { t } = useTranslation()
  document.title = 'Staff | ' + t('name')

  //State manager initialization
  const dispatch = useDispatch()
  const [contentPerPage] = useState(10)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [tableArray, setTableArray] = useState(null)
  const [pagination, setPagination] = useState('')
  const [staffList, setStaffList] = useState('')
  const [modalEdit, setModalEdit] = useState(false)
  const [currentRequest, setCurrentRequest] = useState('')
  const [myCurrentId, setMyCurrentId] = useState('')
  const [brachList, setBranchList] = useState(null)
  const [currentModalBlock, setCurrentModalBlock] = useState('general')
  const allBranches = useSelector(state => state.mainReducer.branches)
  const [studentPhoto, setStudentPhoto] = useState(defaultImage)
  const [photo, setPhoto] = useState(null)
  const [deleted, setDeleted] = useState(0)
  const setDefaultImage = defaultImage

  const [statusSelect, setStatusSelect] = useState(null)
  const [exemptionSelect, setExemptionSelect] = useState(null)
  const [exemptionStatusSelect, setExemptionStatusSelect] = useState(null)
  const [placementSelect, setPlacementSelect] = useState(null)

  //Initialization form in modal
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      staffValues: {
        id: '',
        name: '',
        surname: '',
        phone: '',
        branchCode: '',
        email: '',
        mobile: '',
        gender: '',
        index: '',
        code: '',
        address: '',
        city: '',
        birth_date: '',
        branch_code: '',
        status_code: '',
        exemption_code: '',
        exemption_status_code: '',
        placement_status_code: '',
        availability_placement_department: '',
        work: '',
        duty: '',
        demobilized_soldier: '',
        ultra_orthodox_project: '',
        placement_update_at: '',
        notes: '',
      },
    },
    reValidateMode: 'onChange',
  })

  //Request for all Branches
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/branches/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        dispatch(branchesAdd(data.data))
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for all Statuses
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/statuses/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setStatusSelect(
          Object.values(data.data).map(child => {
            return (
              <option key={child.id} value={child.id}>
                {child.code}
              </option>
            )
          })
        )
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for all Exemptions
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/exemptions/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setExemptionSelect(
          Object.values(data.data).map(child => {
            return (
              <option key={child.id} value={child.id}>
                {child.code}
              </option>
            )
          })
        )
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for all Exemption statuses
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/exemption-statuses/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setExemptionStatusSelect(
          Object.values(data.data).map(child => {
            return (
              <option key={child.id} value={child.id}>
                {child.code}
              </option>
            )
          })
        )
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for all Placements
  useEffect(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/placements-statuses/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        setPlacementSelect(
          Object.values(data.data).map(child => {
            return (
              <option key={child.id} value={child.id}>
                {child.code}
              </option>
            )
          })
        )
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  useEffect(() => {
    if (allBranches) {
      setBranchList(
        Object.values(allBranches).map(child => {
          return (
            <option key={child.id} value={child.id}>
              {child.code}
            </option>
          )
        })
      )
    }
  }, [allBranches])

  const getAllStaff = useCallback(() => {
    const ajaxBody = {}
    const method = 'post'
    const ajaxUrl = 'manager/students/getAll'

    const promise = new Promise((resolve, reject) => {
      Ajax(ajaxBody, ajaxUrl, resolve, method)
    })

    promise.then(data => {
      const dataResponse = data.responseCode.responseCode
      if (dataResponse === '1') {
        const newArr = data.data.map(item => {
          const tempObj = {}
          for (let key in item) {
            if (item[key] === null) {
              tempObj[key] = ''
              continue
            }
            tempObj[key] = item[key]
          }
          return tempObj
        })

        setTableArray(newArr)
      } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
        dispatch(userLogin(false))
        localStorage.removeItem('userToken')
        localStorage.removeItem('userLogin')
      } else {
        console.log(data.responseCode.responseCode)
      }
    })
  }, [dispatch])

  //Request for current table
  useEffect(() => {
    getAllStaff()
  }, [getAllStaff])

  //Request for delete Employer
  const deleteStaff = useCallback(
    event => {
      const ajaxUrl = 'manager/students/delete'
      const ajaxBody = {
        id: myCurrentId,
      }
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          const newDeleteArray = tableArray.slice()
          const indexDelete = newDeleteArray.indexOf(newDeleteArray.find(child => child.id === Number(event.target.dataset.value)))
          newDeleteArray.splice(indexDelete, 1)
          setTableArray(newDeleteArray)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [tableArray, dispatch, myCurrentId]
  )

  const oneStaff = useCallback(
    event => {
      const ajaxUrl = 'manager/students/getOne'
      const ajaxBody = {
        id: event.target.dataset.value,
      }
      setMyCurrentId(event.target.dataset.value)
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          if (data.data.photo) {
            setStudentPhoto(data.data.photo)
          }
          setDeleted(data.data.is_photo)
          setValue(
            'staffValues',
            {
              id: data.data.id_number,
              name: data.data.name,
              code: data.data.code,
              surname: data.data.last_name,
              phone: data.data.phone,
              branchCode: data.data.branch_id,
              email: data.data.email,
              mobile: data.data.mobile,
              gender: data.data.gender,
              index: data.data.index,
              address: data.data.address,
              city: data.data.city,
              birth_date: data.data.birth_date,
              branch_code: data.data.branch_id,
              status_code: data.data.status_id,
              exemption_code: data.data.exemption_id,
              exemption_status_code: data.data.exemption_status_id,
              placement_status_code: data.data.placement_id,
              availability_placement_department: data.data.availability_placement_department,
              work: data.data.work,
              duty: data.data.duty,
              demobilized_soldier: data.data.demobilized_soldier,
              ultra_orthodox_project: data.data.ultra_orthodox_project,
              placement_update_at: data.data.placement_update_at,
              notes: data.data.notes,
            },
            { shouldValidate: true }
          )
          setCurrentRequest('update')
          setModalEdit(true)
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    },
    [setValue, dispatch]
  )

  const sendStaff = data => {
    if (currentRequest === 'add') {
      const formData = new FormData()
      formData.append('password', 123456)
      formData.append('password_confirmation', 123456)
      formData.append('photo', photo)
      formData.append('id_number', data.staffValues.id)
      formData.append('name', data.staffValues.name)
      formData.append('last_name', data.staffValues.surname)
      formData.append('email', data.staffValues.email)
      formData.append('is_photo', deleted)
      formData.append('phone', data.staffValues.phone)
      formData.append('mobile', data.staffValues.mobile)
      formData.append('gender', data.staffValues.gender)
      formData.append('index', data.staffValues.index)
      formData.append('address', data.staffValues.address)
      formData.append('city', data.staffValues.city)
      formData.append('birth_date', data.staffValues.birth_date)
      formData.append('branch_id', data.staffValues.branchCode)
      formData.append('status_id', data.staffValues.status_code)
      formData.append('exemption_id', data.staffValues.exemption_code)
      formData.append('exemption_status_id', data.staffValues.exemption_status_code)
      formData.append('placement_id', data.staffValues.placement_status_code)
      formData.append('availability_placement_department', data.staffValues.availability_placement_department)
      formData.append('work', data.staffValues.work)
      formData.append('duty', data.staffValues.duty)
      formData.append('demobilized_soldier', data.staffValues.demobilized_soldier)
      formData.append('ultra_orthodox_project', data.staffValues.ultra_orthodox_project)
      formData.append('notes', data.staffValues.notes)

      const ajaxUrl = 'manager/students/add'
      const ajaxBody = formData
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          setPhoto(null)
          reset()
          setModalEdit(false)
          getAllStaff()
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    } else {
      const formData = new FormData()
      formData.append('id', myCurrentId)
      formData.append('password', 123456)
      formData.append('password_confirmation', 123456)
      formData.append('photo', photo)
      formData.append('id_number', data.staffValues.id)
      formData.append('name', data.staffValues.name)
      formData.append('last_name', data.staffValues.surname)
      formData.append('email', data.staffValues.email)
      formData.append('is_photo', deleted)
      formData.append('phone', data.staffValues.phone)
      formData.append('mobile', data.staffValues.mobile)
      formData.append('gender', data.staffValues.gender)
      formData.append('index', data.staffValues.index)
      formData.append('address', data.staffValues.address)
      formData.append('city', data.staffValues.city)
      formData.append('birth_date', data.staffValues.birth_date)
      formData.append('branch_id', data.staffValues.branchCode)
      formData.append('status_id', data.staffValues.status_code)
      formData.append('exemption_id', data.staffValues.exemption_code)
      formData.append('exemption_status_id', data.staffValues.exemption_status_code)
      formData.append('placement_id', data.staffValues.placement_status_code)
      formData.append('availability_placement_department', data.staffValues.availability_placement_department)
      formData.append('work', data.staffValues.work)
      formData.append('duty', data.staffValues.duty)
      formData.append('demobilized_soldier', data.staffValues.demobilized_soldier)
      formData.append('ultra_orthodox_project', data.staffValues.ultra_orthodox_project)
      formData.append('notes', data.staffValues.notes)

      const ajaxUrl = 'manager/students/update'
      const ajaxBody = formData
      const method = 'post'

      const promise = new Promise((resolve, reject) => {
        Ajax(ajaxBody, ajaxUrl, resolve, method)
      })

      promise.then(data => {
        const dataResponse = data.responseCode.responseCode
        if (dataResponse === '1') {
          setPhoto(null)
          reset()
          setModalEdit(false)
          getAllStaff()
        } else if (dataResponse === '105' || dataResponse === '104' || dataResponse === '103') {
          dispatch(userLogin(false))
          localStorage.removeItem('userToken')
          localStorage.removeItem('userLogin')
        } else {
          console.log(data.responseCode.responseCode)
        }
      })
    }
  }

  //Table list for HTML
  useEffect(() => {
    if (tableArray) {
      const lastPageIndex = currentPage * contentPerPage
      const firstPageIndex = lastPageIndex - contentPerPage
      const currentMyPage = tableArray
        .filter(
          element =>
            element.name.toLowerCase().includes(search.toLowerCase()) +
            element.last_name.toLowerCase().includes(search.toLowerCase()) +
            element.phone.toLowerCase().includes(search.toLowerCase()) +
            element.branch_code.toLowerCase().includes(search.toLowerCase()) +
            element.id_number.toLowerCase().includes(search.toLowerCase())
        )
        .slice(firstPageIndex, lastPageIndex)
      if (currentMyPage.length === 0) {
        setStaffList(<p className='nothingFound'>Nothing found</p>)
      } else {
        setStaffList(
          Object.values(currentMyPage).map(child => {
            return (
              <div className='item mainItem' key={child.id} data-value={child.id} onClick={event => oneStaff(event)}>
                <p title={child.name} data-value={child.id}>
                  {child.name}
                </p>
                <p title={child.last_name} data-value={child.id}>
                  {child.last_name}
                </p>
                <p title={child.phone} data-value={child.id}>
                  {child.phone}
                </p>
                <p title={child.id_number} data-value={child.id}>
                  {child.id_number}
                </p>
                <p title={child.branch_code} data-value={child.id}>
                  {child.branch_code}
                </p>
              </div>
            )
          })
        )
        setPagination(
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            search={search}
            allEmployers={tableArray}
            contentPerPage={contentPerPage}
          />
        )
      }
    } else {
      setStaffList(<Loading />)
      setPagination(null)
    }
  }, [tableArray, search, currentPage, contentPerPage, oneStaff, deleteStaff])

  return (
    <section className='staff'>
      <div className='addNew'>
        <h2>Students</h2>
        <Search search={search} setSearch={setSearch} setCurrentPage={setCurrentPage} />
        <button
          value='addNew'
          onClick={function () {
            reset()
            setModalEdit(true)
            setCurrentRequest('add')
          }}>
          Add
        </button>
      </div>
      <div className='table'>
        <div className='item title'>
          <h2>Name</h2>
          <h2>Surname</h2>
          <h2>Phone number</h2>
          <h2>ID</h2>
          <h2>Branch code</h2>
        </div>
        {staffList}
      </div>
      {pagination}
      <Modal active={modalEdit} setActive={setModalEdit} className='studentModal'>
        <h2>Students info</h2>
        <div className='titleButton'>
          <button className={currentModalBlock === 'general' ? 'active' : null} onClick={() => setCurrentModalBlock('general')}>
            General
          </button>
          <button className={currentModalBlock === 'additional' ? 'active' : null} onClick={() => setCurrentModalBlock('additional')}>
            Additional data
          </button>
          <button className={currentModalBlock === 'notes' ? 'active' : null} onClick={() => setCurrentModalBlock('notes')}>
            Notes
          </button>
          <button className={currentModalBlock === 'history' ? 'active' : null} onClick={() => setCurrentModalBlock('history')}>
            History
          </button>
          <button className={currentModalBlock === 'payment' ? 'active' : null} onClick={() => setCurrentModalBlock('payment')}>
            Payment info
          </button>
        </div>
        <div className='modalImageBlock'>
          <div className='firstDiv'>
            <img src={studentPhoto} alt='user' />
            <span
              onClick={() => {
                setPhoto(null)
                setStudentPhoto(setDefaultImage)
                setDeleted(1)
              }}>
              x
            </span>
            <label>
              <p className='button'>{photo ? photo.name : 'Add image'}</p>
              <input
                type='file'
                onChange={event => {
                  setPhoto(event.target.files[0])
                }}
              />
            </label>
          </div>
          <form onSubmit={handleSubmit(sendStaff)} autoComplete='off'>
            <div className={currentModalBlock === 'general' ? 'currentModal' : 'none'}>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>
                      Name <span className='requiredInput'>*</span>
                    </p>
                    <input
                      {...register('staffValues.name', {
                        required: 'This field is required',
                        minLength: {
                          value: 3,
                          message: 'Min length 3',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 50',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('name') ? errors.staffValues.name.message : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>
                      Surname <span className='requiredInput'>*</span>
                    </p>
                    <input
                      {...register('staffValues.surname', {
                        required: 'This field is required',
                        minLength: {
                          value: 3,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 100',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('surname') ? errors.staffValues.surname.message : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>Phone</p>
                    <input
                      type='number'
                      {...register('staffValues.phone', {
                        minLength: {
                          value: 6,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 100,
                          message: 'Max length 100',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('phone') ? errors.staffValues.phone.message : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>
                      Mob phone <span className='requiredInput'>*</span>
                    </p>
                    <input
                      type='number'
                      {...register('staffValues.mobile', {
                        required: 'This field is required',
                        minLength: {
                          value: 6,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 100,
                          message: 'Max length 100',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('mobile') ? errors.staffValues.mobile.message : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>
                      ID <span className='requiredInput'>*</span>
                    </p>
                    <input
                      type='number'
                      {...register('staffValues.id', {
                        required: 'This field is required',
                        minLength: {
                          value: 6,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 50',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('id') ? errors.staffValues.id.message : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Birth day</p>
                    <input
                      {...register('staffValues.birth_date', {
                        minLength: {
                          value: 6,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 50',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('birth_date')
                      ? errors.staffValues.birth_date.message
                      : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>City </p>
                    <input
                      {...register('staffValues.city', {
                        minLength: {
                          value: 6,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 50',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('city') ? errors.staffValues.city.message : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Index</p>
                    <input
                      {...register('staffValues.index', {
                        minLength: {
                          value: 4,
                          message: 'Min length 4',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 50',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('index') ? errors.staffValues.index.message : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>Gender</p>
                    <select {...register('staffValues.gender', {})}>
                      <option value='1'>Man</option>
                      <option value='0'>Women</option>
                    </select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('gender') ? errors.staffValues.gender.message : null}
                  </span>
                </div>
                <div className={currentRequest === 'add' ? 'none' : 'sendButton delete'}>
                  <label>
                    <p>Student code</p>
                    <input readOnly='readonly' {...register('staffValues.code', {})} />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('code') ? errors.staffValues.code.message : null}
                  </span>
                </div>
              </div>
              <label>
                <p>Address </p>
                <input
                  {...register('staffValues.address', {
                    minLength: {
                      value: 6,
                      message: 'Min length 6',
                    },
                    maxLength: {
                      value: 50,
                      message: 'Max length 50',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('address') ? errors.staffValues.address.message : null}
              </span>
              <label>
                <p>
                  Email <span className='requiredInput'>*</span>
                </p>
                <input
                  {...register('staffValues.email', {
                    required: 'This field is required',
                    minLength: {
                      value: 6,
                      message: 'Min length 6',
                    },
                    maxLength: {
                      value: 100,
                      message: 'Max length 100',
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: 'invalid email address',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('email') ? errors.staffValues.email.message : null}
              </span>
            </div>
            <div className={currentModalBlock === 'additional' ? 'currentModal' : 'none'}>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>Branch code</p>
                    <select {...register('staffValues.branchCode', {})}>{brachList}</select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('branchCode')
                      ? errors.staffValues.branchCode.message
                      : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Status code</p>
                    <select {...register('staffValues.status_code', {})}>{statusSelect}</select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('status_code')
                      ? errors.staffValues.status_code.message
                      : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Exemption code</p>
                    <select {...register('staffValues.exemption_code', {})}>{exemptionSelect}</select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('exemption_code')
                      ? errors.staffValues.exemption_code.message
                      : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>Exemption status</p>
                    <select {...register('staffValues.exemption_status_code', {})}>{exemptionStatusSelect}</select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('exemption_status_code')
                      ? errors.staffValues.exemption_status_code.message
                      : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Placement status</p>
                    <select {...register('staffValues.placement_status_code', {})}>{placementSelect}</select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('placement_status_code')
                      ? errors.staffValues.placement_status_code.message
                      : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>Date of Placement status update</p>
                    <input readOnly='readonly' {...register('staffValues.placement_update_at', {})} />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('placement_update_at')
                      ? errors.staffValues.placement_update_at.message
                      : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Availability for the placement department</p>
                    <select {...register('staffValues.availability_placement_department', {})}>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('availability_placement_department')
                      ? errors.staffValues.availability_placement_department.message
                      : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>Work</p>
                    <input
                      {...register('staffValues.work', {
                        minLength: {
                          value: 6,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 50',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('work') ? errors.staffValues.work.message : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Duty</p>
                    <input
                      {...register('staffValues.duty', {
                        minLength: {
                          value: 6,
                          message: 'Min length 6',
                        },
                        maxLength: {
                          value: 50,
                          message: 'Max length 50',
                        },
                      })}
                    />
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('duty') ? errors.staffValues.duty.message : null}
                  </span>
                </div>
              </div>
              <div className='labelDiv'>
                <div>
                  <label>
                    <p>Budgeting of a demobilized soldier</p>
                    <select {...register('staffValues.demobilized_soldier', {})}>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('demobilized_soldier')
                      ? errors.staffValues.demobilized_soldier.message
                      : null}
                  </span>
                </div>
                <div>
                  <label>
                    <p>Budget of an active ultra-orthodox</p>
                    <select {...register('staffValues.ultra_orthodox_project', {})}>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
                  </label>
                  <span className='errorResponse'>
                    {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('ultra_orthodox_project')
                      ? errors.staffValues.ultra_orthodox_project.message
                      : null}
                  </span>
                </div>
              </div>
            </div>
            <div className={currentModalBlock === 'notes' ? 'currentModal' : 'none'}>
              <label>
                <p>Notes</p>
                <textarea
                  {...register('staffValues.notes', {
                    minLength: {
                      value: 6,
                      message: 'Min length 6',
                    },
                    maxLength: {
                      value: 250,
                      message: 'Max length 250',
                    },
                  })}
                />
              </label>
              <span className='errorResponse'>
                {errors.hasOwnProperty('staffValues') && errors.staffValues.hasOwnProperty('notes') ? errors.staffValues.notes.message : null}
              </span>
            </div>
            <div className={currentModalBlock === 'history' ? 'currentModal' : 'none'}></div>
            <div className={currentModalBlock === 'payment' ? 'currentModal' : 'none'}></div>
            <div className='buttons'>
              <input type='submit' className='sendButton' value='Save' disabled={!isValid} />
              <span className={currentRequest === 'add' ? 'none' : 'sendButton delete'} onClick={() => deleteStaff()}>
                Delete
              </span>
            </div>
          </form>
        </div>
      </Modal>
    </section>
  )
}
